import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import { SIGNIN_USER, SIGNOUT_USER } from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import requisicaoApiV2 from 'util/ApiV2';
import {showAuthMessage, userSignInSuccess, userSignOutSuccess } from "actions/Auth";
import md5 from 'md5';
import localforage from 'localforage';

const signInUserWithEmailPasswordRequest = async (login, senha) =>
  await requisicaoApi.post('/seguranca/auth', { "login": login, "senha": senha })
    .then(authUser => authUser)
    .catch(error => error);

function* signInUserWithEmailPassword({payload}) {
  const {login, senha} = payload;
  try {
    const signInUser = yield call(signInUserWithEmailPasswordRequest, login, md5(senha));
    if (signInUser.message) {
      if (signInUser.response)
      {
        if(signInUser.response.status === 401)
        {
          yield put(showAuthMessage(JSON.stringify(signInUser.response.data.mensagem)));
        }
        else
        {
          yield put(showAuthMessage(JSON.stringify(signInUser.message)));
        }
      }
      else
      {
        yield put(showAuthMessage(JSON.stringify(signInUser.message)));
      }
      
    } else {
      const autorizacao = signInUser.data.configuracao.listaConfiguracaoPortalFuncionalideAcao
          .filter(x => x.funcionalidadeAcaoUsuarioPortal.funcionalidadePortal.codigoFuncionalidadePortal == "CADSIMPLIFPERFIL")
          .length === 1;

      const cad_simplif_insert = signInUser.data.configuracao.listaConfiguracaoPortalFuncionalideAcao
        .filter(x => x.funcionalidadeAcaoUsuarioPortal.funcionalidadePortal.codigoFuncionalidadePortal == "PESSCONTTEND")
        .filter(x => x.funcionalidadeAcaoUsuarioPortal.id == 2)
        .length === 1;

      const cad_simplif_remove = signInUser.data.configuracao.listaConfiguracaoPortalFuncionalideAcao
        .filter(x => x.funcionalidadeAcaoUsuarioPortal.funcionalidadePortal.codigoFuncionalidadePortal == "PESSCONTTEND")
        .filter(x => x.funcionalidadeAcaoUsuarioPortal.id == 4)
        .length === 1;

      localStorage.setItem("token", JSON.stringify(signInUser.data.accessToken));
      localStorage.setItem('user_id', signInUser.data.idUsuario);
      localStorage.setItem('user', signInUser.data.nomeExibUsuario)
      localStorage.setItem('user_img', signInUser.data.pathImg)
      localStorage.setItem('perfil', signInUser.data.perfis.filter(x => x.descricaoPerfil === 'Administrador Uzer') ? 'Administrador': '')

      const menusOriginais = Array.isArray(signInUser.data.configuracao.menus) ? JSON.parse(JSON.stringify(signInUser.data.configuracao.menus)) : [];
      let menuCadastros = menusOriginais.find(m => String(m.descricaoMenu || '').toLowerCase() === 'escola');
      if (!menuCadastros) {
        const maiorIdBase = menusOriginais.reduce((acc, m) => {
          const v = Number(m.id);
          return isNaN(v) ? acc : Math.max(acc, v);
        }, 0);
        const maiorOrdemBase = menusOriginais.reduce((acc, m) => {
          const v = Number(m.ordem);
          return isNaN(v) ? acc : Math.max(acc, v);
        }, 0);
        menuCadastros = menusOriginais.find(m => {
          const itens = Array.isArray(m.itensDoMenu) ? m.itensDoMenu : [];
          return itens.some(it => String(it.path || '').toLowerCase() === 'escolas' || String(it.descricaoItem || '').toLowerCase() === 'escolas');
        });
        if (!menuCadastros) {
          menuCadastros = { id: maiorIdBase + 1, descricaoMenu: 'Cadastros', ordem: maiorOrdemBase + 1, itensDoMenu: [] };
          menusOriginais.push(menuCadastros);
        }
      } else {
        // Ajusta nome para 'Cadastros' e evita duplicidade de menus com mesmo título
        menuCadastros.descricaoMenu = 'Cadastros';
        menusOriginais = menusOriginais.filter((m, idx) => {
          const titulo = String(m.descricaoMenu || '').toLowerCase();
          if (titulo !== 'cadastros') return true;
          // mantém o primeiro 'Cadastros' e remove duplicatas posteriores
          const firstIdx = menusOriginais.findIndex(mm => String(mm.descricaoMenu || '').toLowerCase() === 'cadastros');
          return idx === firstIdx;
        });
      }
      const idCadastros = menuCadastros ? menuCadastros.id : null;
      let itemMatriculas = null;
      let idxMenuOrigem = -1;
      let idxItemOrigem = -1;
      for (let i = 0; i < menusOriginais.length; i++) {
        const m = menusOriginais[i];
        const itens = Array.isArray(m.itensDoMenu) ? m.itensDoMenu : [];
        for (let j = 0; j < itens.length; j++) {
          const it = itens[j];
          const ehMatriculas = String(it.path || '').toLowerCase() === 'matriculas' || String(it.descricaoItem || '').toLowerCase() === 'matrículas' || String(it.descricaoItem || '').toLowerCase() === 'matriculas';
          if (ehMatriculas) {
            itemMatriculas = it;
            idxMenuOrigem = i;
            idxItemOrigem = j;
            break;
          }
        }
        if (itemMatriculas) break;
      }
      const existeAnos = menusOriginais.some(m => String(m.descricaoMenu || '').toLowerCase() === 'anos letivos');
      let idAnosLetivos = null;
      if (!existeAnos) {
        const maiorId = menusOriginais.reduce((acc, m) => {
          const v = Number(m.id);
          return isNaN(v) ? acc : Math.max(acc, v);
        }, 0);
        const maiorOrdem = menusOriginais.reduce((acc, m) => {
          const v = Number(m.ordem);
          return isNaN(v) ? acc : Math.max(acc, v);
        }, 0);
        idAnosLetivos = maiorId + 1;
        menusOriginais.push({ id: idAnosLetivos, descricaoMenu: 'Anos letivos', ordem: maiorOrdem + 1, itensDoMenu: [] });
      } else {
        // Consolidar menus "Anos letivos" existentes: manter o primeiro e unificar itens
        const indicesAnos = menusOriginais
          .map((m, idx) => ({ idx, m }))
          .filter(x => String(x.m.descricaoMenu || '').toLowerCase() === 'anos letivos');
        if (indicesAnos.length > 0) {
          const keepIdx = indicesAnos[0].idx;
          const menuKeep = menusOriginais[keepIdx];
          idAnosLetivos = menuKeep.id;
          const mergeItens = [];
          indicesAnos.forEach(({ m }) => {
            const itens = Array.isArray(m.itensDoMenu) ? m.itensDoMenu : [];
            itens.forEach(it => {
              const exists = mergeItens.some(e => String(e.path || '') === String(it.path || '') || Number(e.id || 0) === Number(it.id || 0));
              if (!exists) mergeItens.push(it);
            });
          });
          menuKeep.itensDoMenu = mergeItens;
          // Remove duplicatas posteriores
          for (let k = indicesAnos.length - 1; k >= 1; k--) {
            menusOriginais.splice(indicesAnos[k].idx, 1);
          }
          const maiorOrdemAtual = menusOriginais.reduce((acc, m) => {
            const v = Number(m.ordem);
            return isNaN(v) ? acc : Math.max(acc, v);
          }, 0);
          menuKeep.ordem = maiorOrdemAtual + 1;
        }
      }

      if (itemMatriculas && idAnosLetivos) {
        if (idxMenuOrigem >= 0 && idxItemOrigem >= 0) {
          const itensOrigem = Array.isArray(menusOriginais[idxMenuOrigem].itensDoMenu) ? menusOriginais[idxMenuOrigem].itensDoMenu : [];
          itensOrigem.splice(idxItemOrigem, 1);
          menusOriginais[idxMenuOrigem].itensDoMenu = itensOrigem;
        }
        itemMatriculas.idMenuSistema = idAnosLetivos;
        const menuAnos = menusOriginais.find(m => m.id === idAnosLetivos);
        const listaAnos = Array.isArray(menuAnos.itensDoMenu) ? menuAnos.itensDoMenu : [];
        const jaExisteMat = listaAnos.some(i => String(i.path || '').toLowerCase() === 'matriculas' || String(i.descricaoItem || '').toLowerCase() === 'matriculas' || String(i.descricaoItem || '').toLowerCase() === 'matrículas');
        const novaLista = jaExisteMat ? listaAnos : [...listaAnos, itemMatriculas];
        menuAnos.itensDoMenu = novaLista;
        // Garante que menu "Anos letivos" esteja por último
        const idx = menusOriginais.findIndex(m => m.id === idAnosLetivos);
        if (idx >= 0) {
          const [mov] = menusOriginais.splice(idx, 1);
          menusOriginais.push(mov);
        }
      }

      const menuComunicacao = menusOriginais.find(m => String(m.descricaoMenu || '').toLowerCase() === 'comunica├º├úo')
        || menusOriginais.find(m => {
          const itens = Array.isArray(m.itensDoMenu) ? m.itensDoMenu : [];
          return itens.some(it => String(it.path || '').toLowerCase() === 'notificacao');
        });

      if (menuComunicacao) {
        const itensAtuais = Array.isArray(menuComunicacao.itensDoMenu) ? menuComunicacao.itensDoMenu : [];
        const jaExisteEnquetes = itensAtuais.some(it => String(it.path || '').toLowerCase() === 'enquetes');

        if (!jaExisteEnquetes) {
          const maiorIdItem = itensAtuais.reduce((acc, it) => {
            const valor = Number(it.id);
            return isNaN(valor) ? acc : Math.max(acc, valor);
          }, 0);

          itensAtuais.push({
            id: maiorIdItem + 1,
            descricaoItem: 'Enquetes',
            path: 'enquetes',
            rota: 'routes/comunicacao/enquetes/index',
            ordem: 2,
            idMenuSistema: menuComunicacao.id,
            ehSomenteRota: false
          });

          menuComunicacao.itensDoMenu = itensAtuais;
        }
      }

      const configuracaoAtualizada = {
        visualizaDadosPortaria: signInUser.data.configuracao.visualizaDadosPortaria,
        concedeAcessos: signInUser.data.configuracao.concedeAcessos,
        listaPontosAcessoPortaria: signInUser.data.configuracao.listaPontosAcessoPortaria,
        listaConfiguracaoPortalFuncionalideAcao: signInUser.data.configuracao.listaConfiguracaoPortalFuncionalideAcao,
        uzerAcessoAmbienteCliente: signInUser.data.configuracao.uzerAcessoAmbienteCliente,
        uzerAcessoPainelAdministrativo: signInUser.data.configuracao.uzerAcessoPainelAdministrativo,
        idPerfilSistema: signInUser.data.configuracao.idPerfilSistema,
        menus: menusOriginais,
        modulos: signInUser.data.modulos
      };

      localStorage.setItem('cfg', JSON.stringify(configuracaoAtualizada))
      localStorage.setItem('cad_simplif_perfil', autorizacao)
      localStorage.setItem('cad_simplif_insert', cad_simplif_insert)
      localStorage.setItem('cad_simplif_remove', cad_simplif_remove)
      yield put(userSignInSuccess(signInUser.data.idUsuario, signInUser.data.perfis, configuracaoAtualizada));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signOut() {
  try {
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      localStorage.removeItem('user')  
      localStorage.removeItem('user_img')         
      localStorage.removeItem('cad_simplif_perfil')
      localStorage.removeItem('cad_simplif_insert')
      localStorage.removeItem('cad_simplif_remove')
      yield put(userSignOutSuccess(signOutUser));
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
  yield all([fork(signInUser),
    fork(signOutUser)]);
}
